import React, { useEffect, useState } from "react";
import { icon, IconComponent, OptionsPanelContainer } from "../../../../../../../common/components";
import Box from "../../../../box/Box";
import { useApi } from "../../../../../../../common/hooks";
import formStudioService from "../../../../../../../api/services/back-office/form-studio-service";
import { isNonEmptyArray } from "../../../../../../../common/utils";
import styles from "./CriteriaList.module.css";
import { CRITERIA_TYPES } from "../../../constants";
import { translateEnumTypes } from "../../../utils";

export default function CriteriaList({ criteria }) {
	const [usedCriteria, setUsedCriteria] = useState([]);
	const { call: getViewCriteria } = useApi(formStudioService.getViewCriteria);
	const { id } = criteria;
	useEffect(() => {
		getViewCriteria({ pageId: id })
			.then((data) => setUsedCriteria(data))
			.catch(console.error);
	}, [getViewCriteria, id]);
	const rowRenderer = (row) => (
		<Box
			key={row.id}
			content={
				<span className={styles.criteriaType}>
					<IconComponent icon={icon[CRITERIA_TYPES[row.type]?.icon]} />
					<span>{(row?.type && translateEnumTypes(CRITERIA_TYPES[row?.type]?.name)) || " - "}</span>
				</span>
			}
			id={row.id}
			title={row.name}
		/>
	);
	return (
		<OptionsPanelContainer className={styles.main}>
			{isNonEmptyArray(usedCriteria) && usedCriteria.map((row) => rowRenderer(row))}
		</OptionsPanelContainer>
	);
}
